import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Skeleton } from "@/components/ui/skeleton";

export function BusinessEntrySkeleton() {
  return (
    <article className="flex-1 flex flex-col overflow-hidden border border-[#E8E8E8] rounded-xl bg-white">
      <AspectRatio ratio={3 / 2}>
        <Skeleton className="w-full h-full rounded-none" />
      </AspectRatio>

      <div className="px-3 pt-2.5 pb-3 flex flex-col gap-1.5 flex-1">
        <Skeleton className="w-36 h-3" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-24 h-5" />
        <Skeleton className="w-3/4 h-3" />
        <div className="flex gap-1">
          <Skeleton className="w-14 h-5 rounded-full" />
          <Skeleton className="w-16 h-5 rounded-full" />
        </div>
      </div>
    </article>
  );
}

BusinessEntrySkeleton.displayName = "BusinessEntrySkeleton";
